import { FC } from 'react';
import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from '@stripe/react-connect-js';

import { useStripeConnect } from '../../hooks/useStripeConnect';

interface MerchantOnboardingProps {
  onExit: () => void;
}

export const MerchantOnboarding: FC<MerchantOnboardingProps> = ({ onExit }) => {
  const { stripeConnectInstance } = useStripeConnect();

  return (
    <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
      <ConnectAccountOnboarding
        collectionOptions={{ fields: 'eventually_due' }}
        onExit={onExit}
      />
    </ConnectComponentsProvider>
  );
};
